import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, reactive, ref, toRefs
} from 'vue';
import GroupIcon from '@/components/svg/group.svg?inline';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import { useProjectGuests } from '@/views/project-guests/composables/useProjectGuests';
import BCXConfirm from '@/components/molecules/BCXConfirm.vue';
import useBCXConfirm from '@/mixins/useBCXConfirm';
import { ProjectListProject } from '@/views/project-forum/models/ProjectForum';
import MemberProjectList from '@/views/project-guests/components/MemberProjectList.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { getDisplayName } from '@/utils/user';
import { BaseUserWithRole } from '@/models/User';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';
import MarvinHappy from '@/components/svg/marvin/marvin_happy.svg?inline';
import MemberTable from '@/views/project-guests/components/MemberTable.vue';
import useProjectGuestState from '@/state/projectGuestState';
import BCXRadio from '@/components/molecules/forms/BCXRadio.vue';
import toggleArrayItem from '@/utils/toggleArrayItem';
import { CompanyGuestListResponse } from '@/models/Company';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberList',
  props: {
  type: {
    type: String as PropType<'guest' | 'employee'>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const isHelptextVisible = ref(false);
const { type } = toRefs(props);

const { guests, employees } = useProjectGuests();
const {
  addGuestToProject,
  deleteCompanyGuest,
  disableCompanyGuest,
  reactivateCompanyGuest,
  removeGuestFromProject,
  resendCompanyGuestInvite
} = useProjectGuestState();

const members = computed(() => {
  const members = (type.value === 'guest' ? guests.value : employees.value);
  return members;
});

const total = computed(() => members.value?.length ?? 0);

const { showConfirm: showDeleteConfirm, ask: askDelete, onConfirm: onConfirmDelete } = useBCXConfirm();
const { showConfirm: showDeactivateDeleteConfirm, ask: askDeactivateDelete, onConfirm: onConfirmDeactivateDelete } = useBCXConfirm();
const { showConfirm: showResendConfirm, ask: askResend, onConfirm: onConfirmResend } = useBCXConfirm();
const { showConfirm: showReactivateConfirm, ask: askReactivate, onConfirm: onConfirmReactivate } = useBCXConfirm();
const { showConfirm: showResendSuccessfulPopup, ask: askResendSuccessfulPopup, onConfirm: onConfirmResendSuccessfulPopup } = useBCXConfirm();

const confirmVars = reactive({
  displayName: '',
  email: ''
});

const setMemberDetailsForConfirm = (member: CompanyGuestListResponse) => {
  confirmVars.displayName = getDisplayName(member as BaseUserWithRole);
  confirmVars.email = member.email ?? getDisplayName(member as BaseUserWithRole);
};

const onSendAgain = async (member: CompanyGuestListResponse) => {
  setMemberDetailsForConfirm(member);
  const result = await askResend();
  if (!result) return;
  if (type.value === 'guest') {
    await resendCompanyGuestInvite(member.inviteId);
    showResendSuccessfulPopup.value = true;
  }
};

const deleteAction = ref<1 | 2 | null>(null);
const deleteActionOptions = ref([
  { value: 2, label: 'delete' },
  { value: 1, label: 'deactivate' }
]);

const onDeactivateDelete = async (member: CompanyGuestListResponse) => {
  setMemberDetailsForConfirm(member);
  deleteAction.value = null;
  const result = await askDeactivateDelete();
  if (!result) return;
  if (type.value === 'guest') {
    if (deleteAction.value === 1) {
      await disableCompanyGuest(member.inviteId);
    } else if (deleteAction.value === 2) {
      await deleteCompanyGuest(member.inviteId);
    }
  }
};

const onDelete = async (member: CompanyGuestListResponse) => {
  setMemberDetailsForConfirm(member);
  const result = await askDelete();
  if (!result) return;
  if (type.value === 'guest') {
    if (member.inviteId) {
      deleteCompanyGuest(member.inviteId);
    }
  }
};

const onReactivate = async (member: CompanyGuestListResponse) => {
  setMemberDetailsForConfirm(member);
  const result = await askReactivate();
  if (!result) return;
  if (type.value === 'guest') {
    await reactivateCompanyGuest(member.inviteId);
    member.active = true;
  }
};

const onDeleteMemberProject = async (member: CompanyGuestListResponse, project: ProjectListProject) => {
  if (member.id) {
    await removeGuestFromProject(member.id, project.id);
  }
};

const onAddMemberProject = (member: CompanyGuestListResponse, project: ProjectListProject) => {
  if (member.id) {
    addGuestToProject(member.id, project.id);
  }
};

const openStates = ref<string[]>([]);
const toggleState = (id: string) => {
  toggleArrayItem(openStates.value, id);
};


return { __sfc: true,props, isHelptextVisible, type, guests, employees, addGuestToProject, deleteCompanyGuest, disableCompanyGuest, reactivateCompanyGuest, removeGuestFromProject, resendCompanyGuestInvite, members, total, showDeleteConfirm, askDelete, onConfirmDelete, showDeactivateDeleteConfirm, askDeactivateDelete, onConfirmDeactivateDelete, showResendConfirm, askResend, onConfirmResend, showReactivateConfirm, askReactivate, onConfirmReactivate, showResendSuccessfulPopup, askResendSuccessfulPopup, onConfirmResendSuccessfulPopup, confirmVars, setMemberDetailsForConfirm, onSendAgain, deleteAction, deleteActionOptions, onDeactivateDelete, onDelete, onReactivate, onDeleteMemberProject, onAddMemberProject, openStates, toggleState, GroupIcon, BCXHelpTextTriggerIcon, BCXInfoCollapsible, BCXConfirm, MemberProjectList, BCXMarkdown, MarvinInfoBox, MarvinHappy, MemberTable, BCXRadio }
}

})